const DiscountCampaignType = {
  Regular: "regular",
  PaymentMethod: "payment-method",
};

export default DiscountCampaignType;
